import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { LocalstorageService } from '@services/localstorage.service';
import { LOCALSTORAGE } from '../constants/constants';

export const authGuard: CanMatchFn = (route, segments) => {
  const router = inject(Router);
  const allowedRoles = route.data?.['roles'];

  const localStorageService = inject(LocalstorageService);
  const token = localStorageService.getItem(LOCALSTORAGE.TOKEN);
  const userRole = localStorageService.getItem(LOCALSTORAGE.USER)?.role;

  const isAuthorized = token && allowedRoles.includes(userRole);
  if (isAuthorized) {
    return true;
  } else {
    router.parseUrl('/auth/login');
  }
  return false;
};
